import React from "react";
import ScoreHorizontal from 'components/common/ScoreHorizontal'
import { findArray } from 'helpers/utils'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStop,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
import {
  RESULT_STATUS,
  getResultStatusAsInteger,
} from "helpers/status";
import Label from "components/general/Label";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const WreScore = ({ data }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()

  let score;
  if (data?.results) {
    const resultStatus = data?.results?.status?.code;
    let noExpandible = true;
    let resultCode = findArray(data?.results?.extendedInfos, { ei_code: ['RES_CODE'] }).ei_value;
    let duration = findArray(data?.results?.extendedInfos, { ei_code: ['DURATION'] })?.ei_value;

    let home = findArray(data?.results?.items, { startSortOrder: [1] });
    let away = findArray(data?.results?.items, { startSortOrder: [2] });

    let tieBreak = findArray(data?.results?.extendedInfos, { ei_code: ['TB_CODE'] }).ei_value;

    let homeColor = findArray(home?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] })?.eue_value?.toLowerCase();
    let awayColor = findArray(away?.eventUnitEntries, { eue_code: ['UNIFORM', 'COLOUR'] })?.eue_value?.toLowerCase();
    let shortDescription = data?.results?.eventUnit?.shortDescription;
    let numberGame = findArray(data?.results?.extendedInfos, { ei_code: ['UNIT_NUMBER'] }).ei_value;

    let presentationGame = shortDescription;
    if (numberGame) {
      presentationGame = <>{presentationGame} - <Label data='HeaderMatch' /> {numberGame}</>
    }

    score = <ScoreHorizontal
      data={data}

      homeUniform={homeColor.length > 1 ? homeColor : 'silver'}
      awayUniform={awayColor.length > 1 ? awayColor : 'silver'}

      noExpandible={noExpandible}

      homeResult={home?.extendedResults?.find(filter => (filter.er_code === 'TECH_PTS'))?.er_value}
      awayResult={away?.extendedResults?.find(filter => (filter.er_code === 'TECH_PTS'))?.er_value}
      homeResultClass={home?.extendedResults?.find(filter => (filter.er_code === 'LEADER'))?.er_value ? 'text-decoration-underline' : ''}
      awayResultClass={away?.extendedResults?.find(filter => (filter.er_code === 'LEADER'))?.er_value ? 'text-decoration-underline' : ''}
      scoreHeader={{
        left: <>{presentationGame}</>
      }}

      scoreBody={{
        bottom: <>{getResultStatusAsInteger(resultStatus) > RESULT_STATUS.START_LIST ? <CautionsAndChallenges data={data} /> : ''}</>
      }}
      scoreFooter={
        {
          top: <div className="w-100">
            <div className="w-100 text-center"><strong>{resultCode && <SportCode code={resultCode} discipline={mirs_discipline} entity="@ResultCode" />}</strong></div>
            <div className="w-100 text-center"><strong>{duration}</strong></div>
          </div>,
          bottom: tieBreak && <><Label data="LabelTieBreakCriteria" /> <SportCode code={tieBreak} discipline={mirs_discipline} entity="@TieBreak" /></>
        }
      }
    />

  }
  return (
    <>
      {score}
    </>
  )
}


function CautionsAndChallenges({ data }) {
  let home = findArray(data?.results?.items, { startSortOrder: [1] });
  let homeCaution = home?.extendedResults?.find(filter => (filter.er_code === 'CAUTION'))?.er_value;
  let homeChallenges = home?.extendedResults?.find(filter => (filter.er_code === 'CHALLENGES_REMAIN'))?.er_value;
  let homeVideo = home?.extendedResults?.find(filter => (filter.er_code === 'CHALLENGE'))?.er_value;
  let away = findArray(data?.results?.items, { startSortOrder: [2] });
  let awayCaution = away?.extendedResults?.find(filter => (filter.er_code === 'CAUTION'))?.er_value;
  let awayChallenges = away?.extendedResults?.find(filter => (filter.er_code === 'CHALLENGES_REMAIN'))?.er_value;
  let awayVideo = away?.extendedResults?.find(filter => (filter.er_code === 'CHALLENGE'))?.er_value;

  let homeCautionYellow;
  let awayCautionYellow;

  for (let i = 0; i < parseInt(homeCaution); i++) {
    homeCautionYellow = <>{homeCautionYellow} <FontAwesomeIcon className='icon-yellow' icon={faStop} /></>
  }
  for (let i = 0; i < parseInt(awayCaution); i++) {
    awayCautionYellow = <>{awayCautionYellow} <FontAwesomeIcon className='icon-yellow' icon={faStop} /></>
  }

  return (
    <div className="w-100">
      <div className="row align-items-center">
        <div className="p-0 text-end col">
          {homeCautionYellow}
        </div>
        <div className="p-0 text-center col-3">
          <strong><Label data="LabelCautions" /></strong>
        </div>
        <div className="p-0 text-start col">
          {awayCautionYellow}
        </div>
      </div>
      <div className="row align-items-center">
        <div className="p-0 col d-flex align-items-center justify-content-end">
          <div className="float-end">{homeVideo && <FontAwesomeIcon icon={faVideo} />}</div>
          <div className="fw-bold ms-2 float-end text-center score-horizontal-circle">{homeChallenges}</div>
        </div>
        <div className="p-0 text-center col-3">
          <strong><Label data="LabelChallenges" /></strong>
        </div>
        <div className="p-0 text-start col d-flex align-items-center">
          <div className="fw-bold me-2 float-start text-center score-horizontal-circle">{awayChallenges}</div>
          <div className="float-start">{awayVideo && <FontAwesomeIcon icon={faVideo} />}</div>
        </div>
      </div>
    </div>
  )
}

export default WreScore;